import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const utcNow = () => {
  return dayjs.utc(dayjs().format("YYYY-MM-DD HH:mm:ss"));
};
